import { motion } from "framer-motion";
import Background from "@/components/Background";
import Header from "@/components/Header";
import Hero from "@/components/Hero";
import Marquee from "@/components/Marquee";
import WhatIsTedOps from "@/components/WhatIsTedOps";
import Workflow from "@/components/Workflow";
import Impact from "@/components/Impact";
import Capabilities from "@/components/Capabilities";
import EndToEnd from "@/components/EndToEnd";
import AiAct from "@/components/AiAct";
import Challenge from "@/components/Challenge";
import Integrations from "@/components/Integrations";
import Blog from "@/components/Blog";
import Cta from "@/components/Cta";
import HomeMarketing from "@/components/HomeMarketing";
import HomeFinance from "@/components/HomeFinance";
import SiteFooter from "@/components/Footer";

const EASE = [0.22, 1, 0.36, 1];

const HeroBar = () => (
    <motion.footer
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ delay: 1.5, duration: 1, ease: EASE }}
        className="relative z-10 flex items-center justify-between px-6 py-5 sm:px-12"
        data-testid="holding-footer"
    >
        <p className="font-mono-brand text-[10px] uppercase tracking-[0.25em] text-[#475569] sm:text-xs">
            © 2026 TED Ops AI
        </p>
        <a
            href="mailto:enquires@tedopsai.com"
            className="flex items-center gap-2.5 font-mono-brand text-[10px] uppercase tracking-[0.25em] text-[#475569] transition-colors hover:text-[#00E5FF] sm:text-xs"
            data-testid="footer-email-link"
        >
            <span className="status-dot h-1.5 w-1.5 rounded-full bg-[#00E5FF]" />
            enquires@tedopsai.com
        </a>
    </motion.footer>
);

export default function Home() {
    return (
        <div className="relative bg-[#060A12] text-[#F8FAFF]" data-testid="holding-page">
            <Header />
            <div aria-hidden="true" className="h-[88px]" />
            <div className="relative flex h-[calc(100svh-88px)] w-full flex-col overflow-hidden">
                <Background />
                <div className="grain-overlay" />
                <Hero />
                <Marquee />
                <HeroBar />
            </div>
            <WhatIsTedOps />
            <HomeMarketing />
            <Workflow />
            <Impact />
            <Capabilities />
            <EndToEnd />
            <HomeFinance />
            <AiAct />
            <Challenge />
            <Integrations />
            <Blog />
            <Cta />
            <SiteFooter />
        </div>
    );
}
